import { Palette } from '../../lib/types/StyleTypes';
import { luminance } from '../../lib/utils/styleUtils';

const ffPalette: Palette = {

  /* --------- Brand --------- */

  primary: '#00BA99',
  secondary: '#FBC0CB',
  errorBorderRed: '#FF0000',
  tertiary: '#6ABED1',
  quaternary: '',

  /* ----------- UI ---------- */

  // Text
  title: '#3E3F42',
  header: '#323332',
  subHeader: '#8D8D8D',
  body: '#232218',
  emphasis: '',
  label: '#323332',

  /* --------- Layout --------- */

  // Background
  bgPrimary: '#F1F3F6',
  bgSecondary: '#FFFFFF',

  // Navigation Menu
  nav: '#1B3345',
  navHover: '#1F2430',
  navActive: '#1F2430',
  navLink: '#788195',
  navLinkHover: '#FFFFFF',
  navLinkActive: '#FFFFFF',

  // Default Table
  tableHeader: '#788195',
  tableHeaderBg: '#F1F3F6',
  tableBody: '#979797',
  tableBodyBg: '#FFFFFF',
  tableRow: '#979797',
  tableRowBg: '#FFFFFF',
  tableColumn: '#FFFFFF',
  tableColumnBg: '#2D3347',

  // Status
  status01: '#E8D069',
  status02: '#FF9076',
  statusO3: '#CA73A3',
  status04: '#00C2A0',
  status05: '#FA5571',
  status06: '#788195',
  active: '#00B694',
  inactive: '#FF0045',

  /* --------- Universal --------- */

  // Neutral
  black: '#000000',
  grey90: luminance('#787878', -0.8),
  grey80: luminance('#787878', -0.6),
  grey70: luminance('#787878', -0.4),
  grey60: luminance('#787878', -0.2),
  grey50: luminance('#787878', 0),
  grey40: luminance('#787878', 0.2),
  grey30: luminance('#787878', 0.4),
  grey20: luminance('#787878', 0.6),
  grey10: luminance('#787878', 0.9),
  grey05: luminance('#787878', 0.95),
  grey02: luminance('#787878', 0.98),
  grey01: luminance('#787878', 1),
  grey: '#D6D7D6',
  white: '#FFFFFF',

  darkBlue: '#466277',

  // Semantic
  error: '#FF0000',
  success: '#50A832',
  warning: '#FFD700',
  info: '#42A5F5',
};

export default ffPalette;
